import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder} from "@angular/forms";

@Component({
  selector: 'app-form-button-submit',
  templateUrl: './form-button-submit.component.html',
  styleUrls: ['./form-button-submit.component.sass']
})
export class FormButtonSubmitComponent {

  @Input() value= '';
  @Input() active = false;
  @Input() name?=  '';
  @Input() label = '';
  @Input() icon = '';
  @Input() error? = false;
  @Input() errorMessage? = '';
  @Output() onClicked = new EventEmitter();
  @Output() onClickedValue = new EventEmitter();

  constructor(private formBuilder: FormBuilder) { }

  onClickedOnSubmitButton(){
    // Only emit if the button is active
    if (this.active) {
      this.onClicked.emit(true);
    }
  }
}
